import { Box, Flex, Input, Select, SimpleGrid, Text } from '@chakra-ui/react';
import { HelperTooltip } from 'components/Tooltip';
import PropTypes from 'prop-types';

export const MARKETING_SPEND_GRACE_TOOLTIP =
  'Number of months after the cohort month before marketing cash spend is booked. 0 books spend in the cohort month. 1 books spend the next month (net 30). Cohort revenue still starts in the cohort month.';

export const REPAYMENT_GRACE_TOOLTIP =
  'Number of months after marketing spend is recognized before repayments begin. 0 means repayments start in the same month as marketing spend. 1 means one month after, and so on.';

function FacilityGracePeriodsRow({
  gracePeriod,
  marketingGracePeriod,
  onChangeGracePeriod,
  onChangeMarketingGracePeriod,
  showRepaymentGrace = true,
  showMarketingGrace = true,
}) {
  const fieldCount = [showRepaymentGrace, showMarketingGrace].filter(Boolean).length;

  return (
    <SimpleGrid columns={{ base: 1, sm: fieldCount > 1 ? 2 : 1 }} spacing={4}>
      {showRepaymentGrace ? (
        <Box>
          <Flex align="center" gap={0} mb={1}>
            <Text fontSize="sm">Repayment grace (months)</Text>
            <HelperTooltip content={REPAYMENT_GRACE_TOOLTIP} />
          </Flex>
          <Input
            aria-label="Repayment grace period (months)"
            type="number"
            value={gracePeriod}
            onChange={(e) => onChangeGracePeriod(Number(e.target.value) || 0)}
          />
        </Box>
      ) : null}
      {showMarketingGrace ? (
        <Box>
          <Flex align="center" gap={0} mb={1}>
            <Text fontSize="sm">Marketing spend grace (months)</Text>
            <HelperTooltip content={MARKETING_SPEND_GRACE_TOOLTIP} />
          </Flex>
          <Select
            aria-label="Marketing spend grace (months)"
            value={String(marketingGracePeriod ?? 1)}
            onChange={(e) => onChangeMarketingGracePeriod(Number(e.target.value))}
          >
            <option value="0">0 — spend in cohort month</option>
            <option value="1">1 — spend next month (net 30)</option>
          </Select>
        </Box>
      ) : null}
    </SimpleGrid>
  );
}

FacilityGracePeriodsRow.propTypes = {
  gracePeriod: PropTypes.number,
  marketingGracePeriod: PropTypes.number,
  onChangeGracePeriod: PropTypes.func.isRequired,
  onChangeMarketingGracePeriod: PropTypes.func.isRequired,
  showRepaymentGrace: PropTypes.bool,
  showMarketingGrace: PropTypes.bool,
};

export default FacilityGracePeriodsRow;
